var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"page-index"},[_c('div',{staticClass:"video"},[_c('video',{staticClass:"lazy",attrs:{"id":"main-video","autoplay":"true","muted":"true","loop":"true","playsinline":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":require(`@/assets/video/${_vm.video}.mp4`),"type":"video/mp4"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }